module.exports = __webpack_public_path__ + "img/icon-discipline.bc9e46fc.svg";